import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { transactionDetailClosingTypeOptions, transactionDetailOptions } from 'constants/options';
import { getConditionalArray } from 'utils/data';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { PropertyAndLoanTestIds } from '../../../../PropertyAndLoan.testIds';

export const transactionDetailsConfigFields = {
  transactionDetail: {
    fieldId: 'transactionDetail',
    type: FieldType.SELECT,
    nameInModel: 'transactionDetail',
    inputProps: {
      options: transactionDetailOptions,
      placeholder: 'Transaction Details',
      label: 'Transaction Details',
      required: false,
    },
  },
  constructionOrImprovementCosts: {
    fieldId: 'constructionOrImprovementCosts',
    type: FieldType.INPUT,
    nameInModel: 'constructionOrImprovementCosts',
    inputProps: {
      type: FieldInputType.CURRENCY,
      placeholder: 'Construction/Improvement Cost',
      label: 'Construction/Improvement Cost',
      dataTestId:
        PropertyAndLoanTestIds.TRANSACTION_DETAILS_FORM_CONSTRUCTION_IMPROVEMENT_COST_INPUT,
      required: false,
      minValue: 0,
    },
  },
  transactionDetailClosingType: {
    fieldId: 'transactionDetailClosingType',
    type: FieldType.SELECT,
    nameInModel: 'transactionDetailClosingType',
    inputProps: {
      options: transactionDetailClosingTypeOptions,
      placeholder: 'Transaction Detail Closing Type',
      label: 'Transaction Detail Closing Type',
      required: true,
    },
  },
  energyRelatedImprovementsIndicator: {
    fieldId: 'energyRelatedImprovementsIndicator',
    type: FieldType.CHECKBOX,
    nameInModel: 'energyRelatedImprovementsIndicator',
    inputProps: {
      label: 'Energy Related Improvements',
      required: false,
    },
  },
  energyImprovementAmount: {
    fieldId: 'energyImprovementAmount',
    type: FieldType.INPUT,
    nameInModel: 'energyImprovementAmount',
    inputProps: {
      type: FieldInputType.CURRENCY,
      placeholder: 'Improvement Amount',
      label: 'Improvement Amount',
      dataTestId: PropertyAndLoanTestIds.TRANSACTION_DETAILS_FORM_IMPROVEMENT_AMOUNT_INPUT,
      required: false,
      disabled: true,
      minValue: 0,
    },
  },
  amountOfEnergyEfficiencyMortgage: {
    fieldId: 'amountOfEnergyEfficiencyMortgage',
    type: FieldType.INPUT,
    nameInModel: 'amountOfEnergyEfficiencyMortgage',
    inputProps: {
      type: FieldInputType.CURRENCY,
      placeholder: 'Amount of Energy Efficiency Mortgage',
      label: 'Amount of Energy Efficiency Mortgage',
      required: false,
      disabled: false,
      minValue: 0,
    },
  },
  listOfEnergyImprovements: {
    fieldId: 'listOfEnergyImprovements',
    type: FieldType.INPUT,
    nameInModel: 'listOfEnergyImprovements',
    inputProps: {
      placeholder: 'List of Energy Improvements',
      label: 'List of Energy Improvements',
      required: false,
      disabled: false,
    },
  },
};

export const transactionDetailsFieldsKeys = Object.keys(transactionDetailsConfigFields);

export const getConfig = compose(
  fillConfigFieldsWithKeys,
  ({
    isConstructionOrImprovementCostsVisible,
    isClosingTypeVisible,
    isEnergyImprovementAmountActive,
  }) => {
    return {
      groups: [
        {
          type: FieldType.GROUP,
          fields: [
            transactionDetailsConfigFields.transactionDetail,
            ...getConditionalArray(isConstructionOrImprovementCostsVisible, [
              transactionDetailsConfigFields.constructionOrImprovementCosts,
            ]),
            ...getConditionalArray(isClosingTypeVisible, [
              transactionDetailsConfigFields.transactionDetailClosingType,
            ]),
          ],
          key: 'transaction-details',
          groupTitle: {
            label: 'Transaction Details',
          },
        },
        {
          type: FieldType.GROUP,
          fields: [transactionDetailsConfigFields.energyRelatedImprovementsIndicator],
          key: 'energy-related-improvements',
          groupTitle: {
            label: 'Energy Related Improvements',
          },
        },
        {
          type: FieldType.GROUP,
          fields: [
            {
              ...transactionDetailsConfigFields.energyImprovementAmount,
              inputProps: {
                ...transactionDetailsConfigFields.energyImprovementAmount.inputProps,
                disabled: !isEnergyImprovementAmountActive,
                required: isEnergyImprovementAmountActive,
              },
            },
            {
              ...transactionDetailsConfigFields.amountOfEnergyEfficiencyMortgage,
              inputProps: {
                ...transactionDetailsConfigFields.amountOfEnergyEfficiencyMortgage.inputProps,
                disabled: !isEnergyImprovementAmountActive,
              },
            },
            {
              ...transactionDetailsConfigFields.listOfEnergyImprovements,
              inputProps: {
                ...transactionDetailsConfigFields.listOfEnergyImprovements.inputProps,
                disabled: !isEnergyImprovementAmountActive,
              },
            },
          ],
          key: 'energy-improvement-amount',
        },
      ],
    };
  },
);
